import { ZfDivider, ZfIcon, ZfLoadingSpinner, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useContentByTalkingPointIdAndDomicile } from '../../../api';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { useYwuApp } from '../../../contexts/ywu-app-context';
import { useNumberSearchParams } from '../../../hooks/useNumberSearchParams';
import { List } from '../../atoms';

const PADDING = 32;
const GAP = 32;
const NEEDS_TITLE_HEIGHT = 28;

interface IProps {
    showBackButton?: boolean;
    containerDimensionsHeight: number;
}

export const TopicDetailPanel: FunctionComponent<IProps> = ({ showBackButton, containerDimensionsHeight }) => {
    const { t, i18n } = useTranslation();
    const { activeTalkingPoint, setActiveTalkingPoint } = useNeedContentContext();
    const { activeDomicile } = useYwuApp();
    const { data: advisoryNeeds } = useContentByTalkingPointIdAndDomicile(activeTalkingPoint?.id, activeDomicile);

    const { setActiveAdvisoryNeed } = useNeedContentContext();
    const [needId] = useNumberSearchParams('adv-need');

    if (!activeTalkingPoint) return null;

    const needsContainerMaxHeight = `${containerDimensionsHeight / 2 - PADDING * 2 - GAP - NEEDS_TITLE_HEIGHT}px`;

    const onBackClick = () => {
        setActiveTalkingPoint(undefined);
    };

    if (!advisoryNeeds) {
        return <ZfLoadingSpinner />;
    }

    return (
        <div className="topic-screen__panel_2">
            <div className="topic-screen__panel_2__header">
                {showBackButton ? (
                    <div className="topic-screen__panel_2__header-button" onClick={onBackClick}>
                        <ZfIcon name="chevron_left" />
                        <h5>{activeTalkingPoint.name[i18n.language]}</h5>
                    </div>
                ) : (
                    <h5>{activeTalkingPoint.name[i18n.language]}</h5>
                )}
            </div>
            <div className="topic-screen__panel_2__description" style={{ overflowY: 'auto' }}>
                <span>{activeTalkingPoint.description[i18n.language]}</span>
            </div>
            <ZfDivider className="mt-auto" />
            <ZfStack direction="column" style={{ padding: 'var(--padding-vertical-xxl) var(--padding-horizontal-xl)' }}>
                <List
                    title={t('titlePotentialAdvisoryNeeds')}
                    items={advisoryNeeds.map((advisoryNeed) => ({
                        title: advisoryNeed.name[i18n.language],
                        data: advisoryNeed,
                    }))}
                    titleSpacing="extra-extra-large"
                    size="large"
                    isSelected={(advisoryNeed) => advisoryNeed.id === needId}
                    onItemClick={(advisoryNeed) => setActiveAdvisoryNeed(advisoryNeed)}
                    hasBorderBottom={(index) => index < advisoryNeeds.length - 1}
                    style={{
                        maxHeight: needsContainerMaxHeight,
                        minHeight: needsContainerMaxHeight,
                        overflowY: 'auto',
                    }}
                />
            </ZfStack>
        </div>
    );
};
